import { memo, useCallback } from 'react';
import ModuleInlineEditingContainer from '../containers/ModuleInlineEditingContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmInlineEditingWrapper = ({
  crmObjectKey,
  moduleName,
  fields,
  values,
  handleInlineCrmFieldChange,
  handleFocusInlineRichTextWithPlaceholder,
  getModuleSchemaById,
  getScpModuleInRichTextByName,
  getSelectedItemId,
  updateStructuredContentMetaData,
  registerInlineFieldRef
}) => {
  // Create a stable onChange handler for this specific crmObjectKey
  const memoizedOnChange = useCallback((path, value) => handleInlineCrmFieldChange(crmObjectKey, path, value), [crmObjectKey, handleInlineCrmFieldChange]);

  // Create a stable updateMetaData function for this specific crmObjectKey
  const memoizedUpdateMetaData = useCallback(metaData => updateStructuredContentMetaData(metaData, crmObjectKey), [crmObjectKey, updateStructuredContentMetaData]);
  return /*#__PURE__*/_jsx(ModuleInlineEditingContainer, {
    moduleName: moduleName,
    onChange: memoizedOnChange,
    fields: fields,
    fieldValues: values,
    inlineType: "crm",
    inlineDataSource: crmObjectKey,
    handleFocusInlineRichTextWithPlaceholder: handleFocusInlineRichTextWithPlaceholder,
    getModuleSchemaById: getModuleSchemaById,
    getScpModuleInRichTextByName: getScpModuleInRichTextByName,
    getSelectedItemId: getSelectedItemId,
    updateMetaData: memoizedUpdateMetaData,
    supportsInlinePlaceholdersAndLabels: true,
    registerInlineFieldRef: registerInlineFieldRef
  });
};
export default /*#__PURE__*/memo(CrmInlineEditingWrapper);